// import { useMemo, useState } from "react";
// import { AnimatePresence, motion } from "framer-motion";
// import { CalendarDays, Check, ChevronDown, Eraser, Globe2, ListFilter, Search, Shapes, Tags } from "lucide-react";
// import { DATE_OPTIONS, NEWS_TYPES, REGIONS, SUBJECTS, countActive } from "../data/News";

// /* ------------------------- accordion section ------------------------ */
// function Section({ icon: Icon, title, badge, defaultOpen = true, children }) {
//   const [open, setOpen] = useState(defaultOpen);
//   return (
//     <div className="border-b border-brand/10 last:border-0">
//       <button
//         onClick={() => setOpen((v) => !v)}
//         className="w-full flex items-center justify-between py-4 group"
//       >
//         <span className="flex items-center gap-2.5">
//           <span className="w-8 h-8 rounded-lg grid place-items-center bg-blush text-brand group-hover:bg-brand group-hover:text-white transition-colors">
//             <Icon className="w-4 h-4" />
//           </span>
//           <span className="text-[13.5px] font-extrabold text-ink">{title}</span>
//           {badge > 0 && (
//             <span className="min-w-5 h-5 px-1.5 rounded-full bg-brand text-white text-[10px] font-extrabold grid place-items-center">
//               {badge}
//             </span>
//           )}
//         </span>
//         <ChevronDown
//           className={`w-4 h-4 text-mute transition-transform duration-300 ${open ? "rotate-180" : ""}`}
//         />
//       </button>
//       <AnimatePresence initial={false}>
//         {open && (
//           <motion.div
//             initial={{ height: 0, opacity: 0 }}
//             animate={{ height: "auto", opacity: 1 }}
//             exit={{ height: 0, opacity: 0 }}
//             transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
//             className="overflow-hidden"
//           >
//             <div className="pb-5 pt-1">{children}</div>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </div>
//   );
// }

// /* ----------------------------- checkbox ----------------------------- */
// function CheckRow({ label, sub, checked, onToggle }) {
//   return (
//     <label className="flex items-start gap-2.5 py-[7px] cursor-pointer group select-none">
//       <span
//         className={`mt-[1px] w-[18px] h-[18px] rounded-[5px] grid place-items-center ring-1 transition-all shrink-0 ${
//           checked
//             ? "bg-gradient-to-br from-crimson to-deeprose ring-transparent shadow-sm shadow-brand/30"
//             : "bg-white ring-ink/20 group-hover:ring-brand"
//         }`}
//       >
//         {checked && <Check className="w-3 h-3 text-white" strokeWidth={3.5} />}
//       </span>
//       <span className={`text-[12.5px] leading-snug transition-colors ${checked ? "text-brand font-bold" : "text-ink/75 group-hover:text-ink"}`}>
//         {label}
//         {sub != null && <span className="ml-1.5 text-[10.5px] font-bold text-mute">({sub})</span>}
//       </span>
//     </label>
//   );
// }

// /* ------------------------------ sidebar ----------------------------- */
// export default function FilterSidebar({ filters, setFilters, onClear, pool, onSearch }) {
//   const [subjectQuery, setSubjectQuery] = useState("");
//   const active = countActive(filters);

//   const toggle = (key, value) =>
//     setFilters((f) => ({
//       ...f,
//       [key]: f[key].includes(value) ? f[key].filter((v) => v !== value) : [...f[key], value],
//     }));

//   const typeCounts = useMemo(() => {
//     const m = {};
//     pool.forEach((n) => (m[n.type] = (m[n.type] || 0) + 1));
//     return m;
//   }, [pool]);

//   const visibleSubjects = useMemo(
//     () => SUBJECTS.filter((s) => s.toLowerCase().includes(subjectQuery.toLowerCase())),
//     [subjectQuery]
//   );

//   const selectedDateLabel = filters.date
//     ? DATE_OPTIONS.find((o) => o.value === filters.date)?.label
//     : "Select";

//   return (
//     <aside className="w-full">
//       <div className="rounded-3xl bg-white ring-1 ring-brand/10 shadow-[0_24px_60px_-30px_rgba(180,35,24,0.25)] overflow-hidden">
//         {/* header */}
//         <div className="px-6 pt-6 pb-4 bg-gradient-to-br from-blush to-cream border-b border-brand/10">
//           <div className="flex items-center justify-between">
//             <p className="flex items-center gap-2 text-[15px] font-extrabold text-ink">
//               <span className="w-8 h-8 rounded-lg bg-gradient-to-br from-crimson to-deeprose grid place-items-center">
//                 <ListFilter className="w-4 h-4 text-white" />
//               </span>
//               Filters
//             </p>
//             {active > 0 && (
//               <span className="text-[11px] font-extrabold text-brand bg-brand/10 rounded-full px-2.5 py-1">
//                 {active} active
//               </span>
//             )}
//           </div>

//           {/* keywords */}
//           <div className="mt-4">
//             <label className="text-[10.5px] font-extrabold uppercase tracking-[0.16em] text-mute">
//               Keywords
//             </label>
//             <div className="mt-2 relative">
//               <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-mute" />
//               <input
//                 value={filters.keyword}
//                 onChange={(e) => setFilters((f) => ({ ...f, keyword: e.target.value }))}
//                 placeholder="Search news…"
//                 className="w-full rounded-xl bg-white ring-1 ring-ink/10 focus:ring-2 focus:ring-brand outline-none py-2.5 pl-10 pr-3 text-[13px] font-semibold placeholder:font-medium placeholder:text-mute/70 transition-shadow"
//               />
//             </div>
//           </div>
//         </div>

//         {/* sections */}
//         <div className="px-6 py-2">
//           {/* <Section icon={Shapes} title="News type" badge={filters.types.length}>
//             {NEWS_TYPES.map((t) => (
//               <CheckRow
//                 key={t}
//                 label={t}
//                 sub={typeCounts[t] ?? 0}
//                 checked={filters.types.includes(t)}
//                 onToggle={() => toggle("types", t)}
//               />
//             ))}
//           </Section> */}

//           <Section icon={Tags} title="States" badge={filters.subjects.length}>
//             <div className="relative mb-2">
//               <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-mute" />
//               <input
//                 value={subjectQuery}
//                 onChange={(e) => setSubjectQuery(e.target.value)}
//                 placeholder="Find a subject…"
//                 className="w-full rounded-lg bg-cream ring-1 ring-ink/10 focus:ring-2 focus:ring-brand outline-none py-2 pl-9 pr-3 text-[12px] font-semibold placeholder:font-medium placeholder:text-mute/70 transition-shadow"
//               />
//             </div>
//             <div className="max-h-[218px] overflow-y-auto slim-scroll pr-2">
//               {visibleSubjects.map((s) => (
//                 <CheckRow
//                   key={s}
//                   label={s}
//                   checked={filters.subjects.includes(s)}
//                   onToggle={() => toggle("subjects", s)}
//                 />
//               ))}
//               {visibleSubjects.length === 0 && (
//                 <p className="text-[12px] text-mute py-3 text-center">No subjects match.</p>
//               )}
//             </div>
//           </Section>

//           <Section icon={CalendarDays} title="Publication date" badge={filters.date ? 1 : 0}>
//             <div className="rounded-xl ring-1 ring-ink/10 overflow-hidden">
//               <div className="px-3.5 py-2.5 bg-cream text-[12.5px] font-bold text-ink flex items-center justify-between">
//                 {selectedDateLabel}
//                 <CalendarDays className="w-3.5 h-3.5 text-mute" />
//               </div>
//               <div className="max-h-[190px] overflow-y-auto slim-scroll bg-white">
//                 <button
//                   onClick={() => setFilters((f) => ({ ...f, date: "" }))}
//                   className={`w-full text-left px-3.5 py-2.5 text-[12.5px] font-semibold flex items-center justify-between hover:bg-blush transition-colors ${
//                     !filters.date ? "text-brand bg-blush" : "text-ink/75"
//                   }`}
//                 >
//                   All dates
//                   {!filters.date && <Check className="w-3.5 h-3.5" strokeWidth={3.5} />}
//                 </button>
//                 {DATE_OPTIONS.map((o) => (
//                   <button
//                     key={o.value}
//                     onClick={() => setFilters((f) => ({ ...f, date: f.date === o.value ? "" : o.value }))}
//                     className={`w-full text-left px-3.5 py-2.5 text-[12.5px] font-semibold flex items-center justify-between hover:bg-blush transition-colors ${
//                       filters.date === o.value ? "text-brand bg-blush" : "text-ink/75"
//                     }`}
//                   >
//                     {o.label}
//                     {filters.date === o.value && <Check className="w-3.5 h-3.5" strokeWidth={3.5} />}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           </Section>

//           <Section icon={Globe2} title="Regions" badge={filters.regions.length}>
//             <div className="flex flex-wrap gap-2 pt-1">
//               {REGIONS.map((r) => {
//                 const on = filters.regions.includes(r);
//                 return (
//                   <button
//                     key={r}
//                     onClick={() => toggle("regions", r)}
//                     className={`px-3.5 py-2 rounded-full text-[12px] font-bold ring-1 transition-all ${
//                       on
//                         ? "bg-gradient-to-r from-crimson to-deeprose text-white ring-transparent shadow-md shadow-brand/25"
//                         : "bg-white text-ink/70 ring-ink/15 hover:ring-brand hover:text-brand"
//                     }`}
//                   >
//                     {r}
//                   </button>
//                 );
//               })}
//             </div>
//           </Section>
//         </div>

//         {/* actions */}
//         <div className="px-6 pb-6 pt-3 flex items-center gap-3">
//           <motion.button
//             whileTap={{ scale: 0.97 }}
//             onClick={onSearch}
//             className="flex-1 inline-flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-crimson to-deeprose text-white text-[13px] font-extrabold py-3 shadow-lg shadow-brand/30 hover:shadow-brand/50 hover:brightness-105 transition-all"
//           >
//             <Search className="w-4 h-4" /> Search
//           </motion.button>
//           <motion.button
//             whileTap={{ scale: 0.97 }}
//             onClick={onClear}
//             disabled={active === 0}
//             className="inline-flex items-center justify-center gap-2 rounded-xl px-4 py-3 text-[13px] font-extrabold ring-1 ring-ink/15 text-ink/70 hover:text-brand hover:ring-brand/50 disabled:opacity-40 disabled:pointer-events-none transition-all"
//           >
//             <Eraser className="w-4 h-4" /> Clear filters
//           </motion.button>
//         </div>
//       </div>

//       <p className="mt-4 text-[11px] text-mute leading-relaxed px-1">
//         Tip — combine subjects, regions and dates to pinpoint exactly the statement or coverage you
//         are looking for.
//       </p>
//     </aside>
//   );
// }






// new new code 



import { useEffect, useMemo, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CalendarDays, Check, ChevronDown, Eraser, Globe2, Search, Tags, X } from "lucide-react";
import { DATE_OPTIONS, REGIONS, SUBJECTS, countActive } from "../data/News";

/* --------------------------- click outside hook ------------------------ */
function useClickOutside(ref, onOutside) {
  useEffect(() => {
    function handler(e) {
      if (ref.current && !ref.current.contains(e.target)) onOutside();
    }
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [ref, onOutside]);
}

/* ------------------------------ checkbox row ---------------------------- */
function CheckRow({ label, checked, onToggle }) {
  return (
    <label className="flex items-start gap-2.5 py-[7px] cursor-pointer group select-none">
      <span
        className={`mt-[1px] w-[18px] h-[18px] rounded-[5px] grid place-items-center ring-1 transition-all shrink-0 ${
          checked
            ? "bg-gradient-to-br from-crimson to-deeprose ring-transparent shadow-sm shadow-brand/30"
            : "bg-white ring-ink/20 group-hover:ring-brand"
        }`}
      >
        {checked && <Check className="w-3 h-3 text-white" strokeWidth={3.5} />}
      </span>
      <span className={`text-[12.5px] leading-snug transition-colors ${checked ? "text-brand font-bold" : "text-ink/75 group-hover:text-ink"}`}>
        {label}
      </span>
    </label>
  );
}

/* ------------------------------ dropdown btn ---------------------------- */
function DropdownButton({ label, icon: Icon, count, isOpen, onOpenChange, width = "w-72", children }) {
  const ref = useRef(null);
  useClickOutside(ref, () => isOpen && onOpenChange(false));

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => onOpenChange(!isOpen)}
        className={`inline-flex items-center gap-2 rounded-xl px-4 py-2.5 text-[12.5px] font-bold ring-1 transition-all whitespace-nowrap ${
          count > 0 || isOpen
            ? "ring-brand/60 text-brand bg-blush"
            : "ring-ink/15 text-ink/70 bg-white hover:ring-brand hover:text-brand"
        }`}
      >
        <Icon className="w-3.5 h-3.5" />
        {label}
        {count > 0 && (
          <span className="min-w-[18px] h-[18px] px-1 rounded-full bg-gradient-to-r from-crimson to-deeprose text-white text-[10px] font-extrabold grid place-items-center">
            {count}
          </span>
        )}
        <ChevronDown className={`w-3.5 h-3.5 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`} />
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -6, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -6, scale: 0.98 }}
            transition={{ duration: 0.16 }}
            className={`absolute left-0 top-[calc(100%+8px)] z-30 ${width} rounded-2xl bg-white ring-1 ring-brand/15 shadow-[0_24px_60px_-20px_rgba(180,35,24,0.35)] p-4`}
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

/* ------------------------------ filter bar ------------------------------ */
export default function FilterSidebar({ filters, setFilters, onClear, pool, onSearch }) {
  const [openKey, setOpenKey] = useState(null);
  const [subjectQuery, setSubjectQuery] = useState("");
  const active = countActive(filters);

  const toggle = (key, value) =>
    setFilters((f) => ({
      ...f,
      [key]: f[key].includes(value) ? f[key].filter((v) => v !== value) : [...f[key], value],
    }));

  const visibleSubjects = useMemo(
    () => SUBJECTS.filter((s) => s.toLowerCase().includes(subjectQuery.toLowerCase())),
    [subjectQuery]
  );

  const selectedDateLabel = filters.date
    ? DATE_OPTIONS.find((o) => o.value === filters.date)?.label
    : "Date";

  return (
    <div className="flex flex-wrap items-center gap-3">
      {/* keyword search */}
      <div className="relative flex-1 min-w-[220px]">
        <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-mute" />
        <input
          value={filters.keyword}
          onChange={(e) => setFilters((f) => ({ ...f, keyword: e.target.value }))}
          placeholder="Search news…"
          className="w-full rounded-xl bg-cream ring-1 ring-ink/10 focus:ring-2 focus:ring-brand outline-none py-2.5 pl-10 pr-9 text-[13px] font-semibold placeholder:font-medium placeholder:text-mute/70 transition-shadow"
        />
        {filters.keyword && (
          <button
            type="button"
            onClick={() => setFilters((f) => ({ ...f, keyword: "" }))}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-mute hover:text-brand"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        )}
      </div>

      {/* states */}
      <DropdownButton
        label="Sectors"
        icon={Tags}
        count={filters.subjects.length}
        isOpen={openKey === "subjects"}
        onOpenChange={(v) => setOpenKey(v ? "subjects" : null)}
        width="w-72"
      >
        <div className="relative mb-3">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-mute" />
          <input
            value={subjectQuery}
            onChange={(e) => setSubjectQuery(e.target.value)}
            placeholder="Find a state…"
            className="w-full rounded-lg bg-cream ring-1 ring-ink/10 focus:ring-2 focus:ring-brand outline-none py-2 pl-9 pr-3 text-[12px] font-semibold placeholder:font-medium placeholder:text-mute/70"
          />
        </div>
        <div className="max-h-[240px] overflow-y-auto slim-scroll pr-1">
          {visibleSubjects.map((s) => (
            <CheckRow
              key={s}
              label={s}
              checked={filters.subjects.includes(s)}
              onToggle={() => toggle("subjects", s)}
            />
          ))}
          {visibleSubjects.length === 0 && (
            <p className="text-[12px] text-mute py-3 text-center">No states match.</p>
          )}
        </div>
      </DropdownButton>

      {/* date */}
      <DropdownButton
        label={selectedDateLabel}
        icon={CalendarDays}
        count={filters.date ? 1 : 0}
        isOpen={openKey === "date"}
        onOpenChange={(v) => setOpenKey(v ? "date" : null)}
        width="w-60"
      >
        <div className="max-h-[240px] overflow-y-auto slim-scroll -m-1 p-1">
          <button
            type="button"
            onClick={() => {
              setFilters((f) => ({ ...f, date: "" }));
              setOpenKey(null);
            }}
            className={`w-full text-left px-3 py-2.5 rounded-lg text-[12.5px] font-semibold flex items-center justify-between hover:bg-blush transition-colors ${
              !filters.date ? "text-brand bg-blush" : "text-ink/75"
            }`}
          >
            All dates
            {!filters.date && <Check className="w-3.5 h-3.5" strokeWidth={3.5} />}
          </button>
          {DATE_OPTIONS.map((o) => (
            <button
              type="button"
              key={o.value}
              onClick={() => {
                setFilters((f) => ({ ...f, date: f.date === o.value ? "" : o.value }));
                setOpenKey(null);
              }}
              className={`w-full text-left px-3 py-2.5 rounded-lg text-[12.5px] font-semibold flex items-center justify-between hover:bg-blush transition-colors ${
                filters.date === o.value ? "text-brand bg-blush" : "text-ink/75"
              }`}
            >
              {o.label}
              {filters.date === o.value && <Check className="w-3.5 h-3.5" strokeWidth={3.5} />}
            </button>
          ))}
        </div>
      </DropdownButton>

      {/* regions */}
      <DropdownButton
        label="Regions"
        icon={Globe2}
        count={filters.regions.length}
        isOpen={openKey === "regions"}
        onOpenChange={(v) => setOpenKey(v ? "regions" : null)}
        width="w-64"
      >
        <div className="flex flex-wrap gap-2">
          {REGIONS.map((r) => {
            const on = filters.regions.includes(r);
            return (
              <button
                type="button"
                key={r}
                onClick={() => toggle("regions", r)}
                className={`px-3.5 py-2 rounded-full text-[12px] font-bold ring-1 transition-all ${
                  on
                    ? "bg-gradient-to-r from-crimson to-deeprose text-white ring-transparent shadow-md shadow-brand/25"
                    : "bg-white text-ink/70 ring-ink/15 hover:ring-brand hover:text-brand"
                }`}
              >
                {r}
              </button>
            );
          })}
        </div>
      </DropdownButton>

      {/* actions */}
      <div className="flex items-center gap-2 w-full sm:w-auto sm:ml-auto justify-end">
        <motion.button
          whileTap={{ scale: 0.96 }}
          onClick={onClear}
          disabled={active === 0}
          className="inline-flex items-center gap-1.5 rounded-xl px-3.5 py-2.5 text-[12.5px] font-extrabold ring-1 ring-ink/15 text-ink/70 hover:text-brand hover:ring-brand/50 disabled:opacity-40 disabled:pointer-events-none transition-all"
        >
          <Eraser className="w-3.5 h-3.5" /> Clear
        </motion.button>
        <motion.button
          whileTap={{ scale: 0.96 }}
          onClick={onSearch}
          className="inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-crimson to-deeprose text-white text-[12.5px] font-extrabold px-5 py-2.5 shadow-md shadow-brand/30 hover:shadow-brand/50 hover:brightness-105 transition-all"
        >
          <Search className="w-3.5 h-3.5" /> Search
        </motion.button>
      </div>
    </div>
  );
}